import React, { ReactElement } from 'react'

export const HorizontalSplit: React.FC = (): ReactElement => (
    <div className='layout-horizontal-split'>
        <svg viewBox='0 0 30 30'>
            <path className='dashboard-layout-outer-border' d='M28,2V28H2V2H28m2-2H0V30H30V0Z' />
            <line className='central-border-line' x1='30' y1='15' y2='15' />
            <rect
                className='dashboard-background-1 dashboard-layout-entry-square'
                x='9'
                y='-5'
                width='12'
                height='26'
                transform='translate(23 -7) rotate(90)'
            />
            <text className='dashboard-foreground-1 dashboard-layout-entry-text' transform='translate(13.64 10.69)'>
                1
            </text>
            <rect
                className='dashboard-background-2 dashboard-layout-entry-square'
                x='9'
                y='9'
                width='12'
                height='26'
                transform='translate(37 7) rotate(90)'
            />
            <text className='dashboard-foreground-2 dashboard-layout-entry-text' transform='translate(13.2 24.69)'>
                2
            </text>
        </svg>
    </div>
)
